import { render } from "./WeekCell.vue?vue&type=template&id=2675b1fa"
import script from "./WeekCell.vue?vue&type=script&lang=js"
export * from "./WeekCell.vue?vue&type=script&lang=js"

import "./WeekCell.vue?vue&type=style&index=0&id=2675b1fa&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__